
import { Component, Vue } from 'vue-property-decorator'
import { logout } from '@/state/Authentication'

@Component
export default class extends Vue {
  beforeRouteEnter(_, __, next) {
    next((vm) => {
      logout(vm.$router, '/')
    })
  }
}
